export default __webpack_public_path__ + "static/media/3.51ec8e0d.png";